import React from 'react';
import { FieldValidationErrorsType } from '../form/FrekulForm';

/**
 * エラーメッセージ
 */
function ErrorMessageItem({
  type,
  message,
}: {
  type: string,
  message: string,
}) {
  let className = '';
  if (type === 'error') {
    className = 'text_error';
  }
  if (type === 'warning') {
    className = 'text_warning';
  }
  if (message === null || message === '') {
    return null;
  }
  return (
    <p className={className} style={{ display: 'block' }}>{message}</p>
  );
}

/**
 * エラーメッセージ
 */
export default function ErrorMessage({
  type,
  validationErrors = {},
}: {
  type: string,
  validationErrors?: FieldValidationErrorsType,
}) {
  return (
    <>
      {Object.entries(validationErrors).map(([rule, message]) => (
        <ErrorMessageItem type={type} key={rule} message={message} />
      ))}
    </>
  );
}
